import { forwardRef } from 'react';

import { cva } from 'cva';
import type { ProgressBarProps as RACProgressBarProps } from 'react-aria-components/ProgressBar';
import { ProgressBar as RACProgressBar } from 'react-aria-components/ProgressBar';

import styles from './progress_circle.module.css';

export type ProgressCircleProps = RACProgressBarProps & {
  className?: string;
  size?: '2xs' | 'xs' | 's' | 'm' | 'l' | 'xl';
};

const progressCircleVariants = cva({
  base: styles.progress_circle,
  variants: {
    size: {
      '2xs': styles.size_2xs,
      xs: styles.size_xs,
      s: styles.size_s,
      m: styles.size_m,
      l: styles.size_l,
      xl: styles.size_xl,
    },
  },
});

export const ProgressCircle = forwardRef<HTMLDivElement, ProgressCircleProps>(
  ({ size, className, isIndeterminate = true, ...props }, ref) => {
    const classes = progressCircleVariants({ size, className });

    return (
      <RACProgressBar
        ref={ref}
        {...props}
        className={classes}
        aria-label={props['aria-label'] || 'Loading'}
      >
        <svg className={styles.svg} viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
            opacity=".25"
          />
          <path
            fill="currentColor"
            d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              dur="0.75s"
              values="0 12 12;360 12 12"
              repeatCount={isIndeterminate ? 'indefinite' : 10}
            />
          </path>
        </svg>
      </RACProgressBar>
    );
  },
);
